import { _ as __assign } from './chunks/bundle-C7jYHvwG.js';
import React__default from 'react';
import { GroupChannelListProvider } from './GroupChannelList/context.js';
import { GroupChannelListUI } from './GroupChannelList/components/GroupChannelListUI.js';
import '@sendbird/chat/groupChannel';
import '@sendbird/uikit-tools';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-gQ2a8Eki.js';
import './chunks/bundle-MyLy9AIu.js';
import './chunks/bundle-DYeeW5nS.js';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-CDjVXDOc.js';
import './chunks/bundle-Dl9NVsui.js';
import './chunks/bundle-DkviGBGz.js';
import './chunks/bundle-DUTyBaXr.js';
import 'react-dom';
import './chunks/bundle-CIN9yQRB.js';
import './chunks/bundle-pOZPN8hk.js';
import './chunks/bundle-DfDrbjM5.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-DImSV9VW.js';
import './ui/Icon.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-4W3uBGU3.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-CLonR-iH.js';
import './chunks/bundle-C6-Ix-Lk.js';
import './ui/SortByRow.js';
import './chunks/bundle-Cq6wCLlD.js';
import './chunks/bundle-Cu4bYcMG.js';
import './GroupChannelList/components/GroupChannelListHeader.js';
import './chunks/bundle-CbEyAimK.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-BR3O1lZq.js';
import './ui/Header.js';
import './ui/TextButton.js';
import './chunks/bundle-Ci2fMtNJ.js';
import './EditUserProfile.js';
import './EditUserProfile/context.js';
import './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-Bk5X1tDl.js';
import './ui/Input.js';
import './ui/PlaceHolder.js';
import './ui/Loader.js';
import './chunks/bundle-DWrM1EW4.js';
import './chunks/bundle-Deel9XzY.js';
import '@sendbird/chat/message';
import './chunks/bundle-DjgT6gu4.js';
import './GroupChannelList/components/GroupChannelPreviewAction.js';
import './GroupChannelList/components/GroupChannelListItem.js';
import './chunks/bundle-BH8ohfFx.js';
import './chunks/bundle-BeUKuH7h.js';
import './chunks/bundle-Bzt5nDi4.js';
import './chunks/bundle-yLTgHCRG.js';
import './chunks/bundle-V4PrrT67.js';
import './chunks/bundle-eYHtE5ry.js';
import './GroupChannel/components/TypingIndicator.js';
import './ui/Badge.js';
import './ui/ChannelAvatar.js';
import './chunks/bundle-TGosz9cX.js';
import './ui/MentionUserLabel.js';
import './chunks/bundle-BMygDCXK.js';
import './chunks/bundle-_-FiwcfQ.js';
import './GroupChannelList/components/AddGroupChannel.js';
import './chunks/bundle-DtycZWOo.js';
import './CreateChannel.js';
import './CreateChannel/components/CreateChannelUI.js';
import './chunks/bundle-CHzQIw7_.js';
import './sendbirdSelectors.js';
import './chunks/bundle-MkyS3j4-.js';
import './CreateChannel/components/InviteUsers.js';
import './ui/UserListItem.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './CreateChannel/components/SelectChannelType.js';

var GroupChannelList = function (props) {
    return (React__default.createElement(GroupChannelListProvider, __assign({}, props),
        React__default.createElement(GroupChannelListUI, __assign({}, props))));
};

export { GroupChannelList, GroupChannelList as default };
//# sourceMappingURL=GroupChannelList.js.map
